import { Navigate } from "react-router-dom"

const Auth = ({component:Component, cprops})=>{
    const auth = localStorage.getItem("auth")
    
    return auth && auth==="admin"? <Component {...cprops} /> : <Navigate to="/" />
}
export default Auth